export default {
    data: () => ({
        translations: {
            title: {
                el: "Επιστροφή Πόντων",
                en: "Points Return",
                it: "Ritorno di punti"
            },
            info: {
                el: "Θέλετε οι πόντοι να επιστρέφονται στον χρήστη μετά τη χρήση του κουπονιού;",
                en:
                    "Do you want points to be returned to the user after using the coupon?",
                it: "Vuoi che i punti vengano restituiti all'utente dopo aver utilizzato il buono?"
            },
            yes: {
                el: "Ναι",
                en: "Yes",
                it: "Sì"
            },
            no: {
                el: "Όχι",
                en: "No",
                it: "No"
            }
        }
    })
};
